module.exports = __webpack_public_path__ + "img/img-6@2x.41c0f3f4.png";